module.exports = __webpack_public_path__ + "img/unknown.960f2dfd.png";